import React from 'react';
import PropTypes from 'prop-types';
import Heading from 'common-ui-components/dist/components/Atoms/Heading';
import Notification from 'common-ui-components/dist/components/Atoms/Notification';
import './ShoppingCartNeedHelp.scss';

const ShoppingCartNeedHelp = props => {
  const {
    needHelp,
    orderSupport,
    contactWaters,
    freightInfo,
    freightPolicy,
    needHelpChatIconUrl,
    needHelpFreightIconUrl,
    contactUsLink,
    freightPolicyLink,
    className,
    showFreightInfo,
    setTarget,
  } = props;
  return (
    <div className={`shoppingCartNeedHelp ${className}`} data-locator="need-help-section">
      <Heading HeadingType="h3" elementLocator="need-help-with-your-order-section">
        {needHelp}
      </Heading>
      <Notification
        description={orderSupport}
        linkText={contactWaters}
        link={{ to: contactUsLink, target: setTarget }}
        icon={needHelpChatIconUrl}
        elementLocator="notification-contact-waters"
      />
      {showFreightInfo && (
        <Notification
          description={freightInfo}
          linkText={freightPolicy}
          link={{ to: freightPolicyLink, target: setTarget }}
          icon={needHelpFreightIconUrl}
          elementLocator="notification-freight-policy"
        />
      )}
    </div>
  );
};

ShoppingCartNeedHelp.propTypes = {
  needHelp: PropTypes.string,
  orderSupport: PropTypes.string,
  freightInfo: PropTypes.string,
  freightPolicy: PropTypes.string,
  contactWaters: PropTypes.string,
  needHelpChatIconUrl: PropTypes.string,
  needHelpFreightIconUrl: PropTypes.string,
  contactUsLink: PropTypes.string,
  freightPolicyLink: PropTypes.string,
  className: PropTypes.string,
  showFreightInfo: PropTypes.bool,
  setTarget: PropTypes.string,
};

ShoppingCartNeedHelp.defaultProps = {
  needHelp: '',
  orderSupport: '',
  freightInfo: '',
  freightPolicy: '',
  contactWaters: '',
  needHelpChatIconUrl: '',
  needHelpFreightIconUrl: '',
  contactUsLink: '',
  freightPolicyLink: '',
  className: '',
  showFreightInfo: true,
  setTarget: '_blank',
};

export default ShoppingCartNeedHelp;
